module.exports = __webpack_public_path__ + "static/img/zongliuliang.4aef4e2a.png";